import { useEffect, useState, CSSProperties } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import useToken from "../../hooks/useToken";


import './SomexConsulta.css'
import { endPoints } from "../../utils/constanst";
import http from "../../services/http";
import { useModal } from './hook'
import { ModalMsgCtrl } from './components'
import { IconNoFound, IconNoValid, IconValid } from './img/index'

const SomexConsulta = () => {
    const { loading } = useToken();

    useEffect(() => {
        if (!loading) {
            const preloader: any = document.querySelector(".site-preloader");
            if (preloader) {
                preloader.addEventListener("transitionend", (event: any) => {
                    if (event.propertyName === "opacity") {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
                preloader.classList.add("site-preloader__fade");
            }
        }
    }, [loading]);

    if (loading) return (<></>);
    return (
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Switch>
                <Route exact path="/micrositio/hn/somex/consulta" component={Layout} />
            </Switch>
        </BrowserRouter>
    );
}
const enum status {
    valid,
    no_valid,
    no_found,
    nd
}

const styleText: CSSProperties = {
    color: '#4D4D4D'
} as CSSProperties;

const Layout = ({ location }: IPropsParam) => {
    const [pol, setPol] = useState({} as any);
    const [technicalData, setTechnicalData] = useState({} as any);
    const loadingModal = useModal({ isloading: true, txtMsg: 'Validando póliza...', active: true } as IModalProps);
    const [polStatus, setPolStatus] = useState(status.nd);

    useEffect(() => {
        GetInfoPol();
    }, [])

    const valid = (data: any) => (data !== undefined && data !== null && data !== 0)
    const formatDate = (value: string) => value === '' ? null : new Date(value).toLocaleDateString();

    const GetIcon = () => {
        switch (polStatus) {
            case status.no_found: return <IconNoFound />
            case status.no_valid: return <IconNoValid />
            case status.valid: return <IconValid />
            default: return <> </>
        }

    }

    const GetInfoPol = () => {
        let searchParams = new URLSearchParams(location.search);
        let code = searchParams.get('codigo') === undefined ? '' : searchParams.get('codigo');

        if (!valid(code)) {

            setPolStatus(status.no_found)
            loadingModal.hide()
            return;
        }

        const pol = code?.split('-');

        if (pol === undefined) {
            setPolStatus(status.no_found)
            loadingModal.hide()
            return;
        }

        if (!valid(pol[0]) && !valid(pol[1]) && !valid(pol[2])) {
            setPolStatus(status.no_found)
            loadingModal.hide()
            return;
        }

        http(endPoints.getPol(pol[0], pol[1], pol[2]))
            .get()
            .then(x => {
                setPol(x);
                setPolStatus(x.codEstado === 'V' ? status.valid : status.no_valid);
                if (x.codEstado === 'V') {
                    loadingModal.show('Cargando datos vehiculo...')
                    http(endPoints.getTechnicalDataPol(x.poliza)).get()
                        .then(x => {
                            setTechnicalData(x);
                        })
                        .catch(() => loadingModal.hide())
                        .finally(() => loadingModal.hide())
                }
                else { loadingModal.hide() }


            })
            .catch(() => {
                setPolStatus(status.no_found)
                loadingModal.hide()
            })


    }

    return (
        <div className="container">
            <div className="layout-somex-hn">
                <div className="mt-10">
                    <p className="t1-somex-hn" style={{ color: '#018765' }}>
                        {polStatus === status.valid && <label>Nos complace informarle que la póliza que acaba de verificar es válida</label>}
                        {polStatus === status.no_found && <label>No se pudo certificar la validez de la póliza</label>}
                        {polStatus === status.no_valid && <label>¡Su póliza ha vencido!</label>}
                    </p>
                </div>
                <div className="mt-40 mb-40" style={{ display: 'flex', justifyContent: 'center' }}>
                    {GetIcon()}
                </div>

                {polStatus === status.no_found && <>
                    <p className="t2-no-somex-hn"><span style={{ fontWeight: 800 }}>Estimado cliente</span> lamentablemente, no logramos certificar la validez de la póliza que ha intentado verificar.</p>
                    <p className="t2-no-somex-hn">Favor comunicarse con nuestras oficinas a través de los siguientes medios:</p>
                </>}
                {polStatus === status.no_valid && <>
                    <p className="t2-no-somex-hn"><span style={{ fontWeight: 800 }}>Estimado cliente</span> su póliza {pol.poliza} venció el {formatDate(pol.fechaFin)}</p>
                    <p className="t2-no-somex-hn">Favor comunicarse con nuestras oficinas a través de los siguientes medios:</p>
                </>}
                {(polStatus === status.no_found || polStatus === status.no_valid) && <>
                    <p style={{ color: '#4D4D4D' }}><span style={{ fontWeight: 900, color: '#018765' }}> Whatsapp Seguros LAFISE:</span> <a className="a-no-decoration" style={{ textDecoration: 'none', outline: "none" }} href="https://wa.me/50433004040">3300-4040</a> <br></br> <span style={{ fontWeight: 900, color: '#018765' }}>PBX SLHN:</span> <a className="a-no-decoration" style={{ textDecoration: 'none', outline: "none" }} href="tel:+50422374000">2237-4000 Ext.10900</a> </p>
                </>}
                {polStatus === status.valid && <p className="t2-no-somex-hn">
                    <label>Detalles de la Póliza: <span style={{ fontWeight: 900 }}>{pol.poliza}</span></label> <br></br>
                    <label>Asegurado: <span style={{ fontWeight: 900 }}>{pol.asegurado}</span></label> <br></br>
                    <label>Vehículo: Marca: <span style={{ fontWeight: 900 }}> {technicalData.marca}</span>, Modelo: <span style={{ fontWeight: 900 }}> {technicalData.modelo}</span>, Placa: <span style={{ fontWeight: 900 }}> {technicalData.placa}</span>, Color: <span style={{ fontWeight: 900 }}> {technicalData.color}</span></label> <br></br>
                    <label>Vigencia: Desde <span style={{ fontWeight: 900 }}> {formatDate(pol.fechaInicio)} </span>  hasta <span style={{ fontWeight: 900 }}> {formatDate(pol.fechaFin)}</span> </label> <br></br>
                </p>}
                <p style={{ color: '#018765', fontSize: '16px' }}>Gracias por confiar en Seguros LAFISE</p>
            </div>
            <ModalMsgCtrl {...loadingModal.modal} closeModal={loadingModal.hide} />
        </div>
    )

}


export default SomexConsulta;